import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import './styles/global.scss'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeCustomization from './mui-theme';
import { Provider } from "react-redux";
import store from "./redux/Store";
import ToastifyProvider from "../src/ui/toastify/ToastifyProvider";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
  {/* <React.StrictMode> */}
     <Provider store={store}>
      <ToastifyProvider>
    <ThemeCustomization>
       <Router>
      <App />
    </Router>
    </ThemeCustomization>
    </ToastifyProvider>
    </Provider>
  {/* </React.StrictMode> */}
    </>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
